// extracted by mini-css-extract-plugin
export default {"josefin-sans-font1":"MainLayout_styles_josefin-sans-font1__XdEho"};